import { MapPin, ArrowUpRight } from "@phosphor-icons/react";
import { COMPANY } from "@/data/company";

export default function MapSection() {
  return (
    <section
      id="map"
      className="py-20 lg:py-28 bg-[#F8FAFC]"
      data-testid="map-section"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-8 items-stretch">
          {/* Left info */}
          <div className="lg:col-span-4 flex flex-col justify-between p-8 lg:p-10 bg-[#0F172A] text-white border-2 border-slate-900 shadow-brutal">
            <div>
              <div className="flex items-center gap-3 mb-4">
                <span className="w-10 h-[2px] bg-[#F59E0B]" />
                <span className="text-xs sm:text-sm font-bold uppercase tracking-[0.25em] text-white/60">
                  Find us
                </span>
              </div>
              <h2 className="font-display font-black text-4xl lg:text-5xl tracking-tighter leading-[0.95]">
                Transport Nagar,
                <br />
                <span className="text-[#F59E0B]">Kanpur.</span>
              </h2>
              <div className="mt-6 flex items-start gap-3 text-white/85">
                <MapPin
                  size={22}
                  weight="duotone"
                  className="text-[#F59E0B] mt-1 shrink-0"
                />
                <div className="text-sm leading-relaxed">
                  {COMPANY.address.line1}
                  <br />
                  {COMPANY.address.line2}
                </div>
              </div>
            </div>
            <a
              href={COMPANY.mapLink}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="map-open-link"
              className="mt-8 inline-flex items-center justify-between gap-3 bg-[#EA580C] text-white font-bold uppercase tracking-wider text-sm px-5 py-4 border-2 border-white/20 transition-brutal hover:bg-[#F59E0B] hover:text-slate-900"
            >
              Open in Google Maps
              <ArrowUpRight size={18} weight="bold" />
            </a>
          </div>

          {/* Map iframe */}
          <div className="lg:col-span-8 border-2 border-slate-900 shadow-brutal overflow-hidden bg-white min-h-[380px]">
            <iframe
              title="Shree Ambey Roadlines HQ - Transport Nagar Kanpur"
              src={COMPANY.mapEmbed}
              width="100%"
              height="100%"
              style={{ border: 0, minHeight: 420 }}
              loading="lazy"
              referrerPolicy="no-referrer-when-downgrade"
              allowFullScreen
              data-testid="map-iframe"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
